/**
 * @readonly
 * @enum {string}
 */
export const ObjectEbsState = Object.freeze({
    AXLE_LOAD: 'axleLoad',
    BRAKE_PERFORMANCE: 'brakePerformance',
    EBS_EVENTS: 'ebsEvents',
    LAST_MODIFIED: 'lastModified',
    OBJECT_ID: 'objectId',
    SPEED: 'speed',
    TIMESTAMP: 'timestamp',
    TYPE: 'type'
})
